import { CATEGORY_TYPE, ITEM_TYPE } from "@constants";
import PropTypes from "prop-types";

import React from "react";
import { shallowEqual, useSelector } from "react-redux";

import {
    FirstBoxCardProduct,
    FirstBoxRedirectCard,
    SecondBoxCardProduct,
} from "./component";

export default function CardProductSimple({
    product,
    opacity,
    quantity,
    isAllergenIconActive,
    setIsAllergenConfirmationDialogOpened,
    handleAddProductClick,
    handleNutritionalInformationDialogOnCloseEvent,
    handleRemoveProductFromOrder,
}) {
    const { isProductDescriptionActive } = useSelector(
        (state) => state.settingSlice.productSetting,
        shallowEqual
    );

    const { isCategorySubCategoryTitleActive } = useSelector(
        (state) => state.settingSlice.productSetting,
        shallowEqual
    );

    const isSubCategoryTitleActive =
        isCategorySubCategoryTitleActive &&
        product.type === CATEGORY_TYPE &&
        (product.isRedirect === undefined || product.isRedirect === false)
            ? product?.isNameDisplayed !== undefined
                ? product?.isNameDisplayed
                : true
            : false;

    const isProductTitleVisible =
        product.type === ITEM_TYPE ||
        (product.type === CATEGORY_TYPE && product.isRedirect === true);

    const isTitleActive =
        isSubCategoryTitleActive ||
        (isProductTitleVisible && product.isTitleShow);

    const isPriceShown =
        product.type !== CATEGORY_TYPE ||
        (product.type === CATEGORY_TYPE &&
            product.isRedirect === true &&
            product.price.content > 0);

    const isProductDescriptionShown =
        isProductDescriptionActive || isPriceShown;

    const isSecondBoxDisplayed =
        isTitleActive || isPriceShown || isProductDescriptionActive;
    const secondBoxHeight =
        product.type === ITEM_TYPE ||
        (isTitleActive && isProductDescriptionShown)
            ? "100px"
            : isTitleActive || isProductDescriptionShown
            ? "50px"
            : "none";
    return (
        <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{
                height: "100%",
            }}
        >
            {product.type === CATEGORY_TYPE ||
            (product.isRedirect === true && !product.offer.isEnabled) ? (
                // Redirect button & sub category
                <>
                    <FirstBoxRedirectCard
                        handleAddProductClick={handleAddProductClick}
                        product={product}
                        isSecondBoxDisplayed={isSecondBoxDisplayed}
                    />
                    {isSecondBoxDisplayed ? (
                        <SecondBoxCardProduct
                            product={product}
                            quantity={quantity}
                            handleAddProductClick={handleAddProductClick}
                            opacity={opacity}
                            isAllergenIconActive={isAllergenIconActive}
                            setIsAllergenConfirmationDialogOpened={
                                setIsAllergenConfirmationDialogOpened
                            }
                            secondBoxHeight={secondBoxHeight}
                            isTitleActive={isTitleActive}
                            isProductDescriptionShown={
                                isProductDescriptionShown
                            }
                            isPriceShown={isPriceShown}
                            isProductDescriptionActive={
                                isProductDescriptionActive
                            }
                        />
                    ) : null}
                </>
            ) : (
                <>
                    <FirstBoxCardProduct
                        product={product}
                        isAllergenIconActive={isAllergenIconActive}
                        setIsAllergenConfirmationDialogOpened={
                            setIsAllergenConfirmationDialogOpened
                        }
                        handleAddProductClick={handleAddProductClick}
                        opacity={opacity}
                        handleNutritionalInformationDialogOnCloseEvent={
                            handleNutritionalInformationDialogOnCloseEvent
                        }
                        quantity={quantity}
                        handleRemoveProductFromOrder={
                            handleRemoveProductFromOrder
                        }
                    />
                    <SecondBoxCardProduct
                        product={product}
                        quantity={quantity}
                        handleAddProductClick={handleAddProductClick}
                        opacity={opacity}
                        isAllergenIconActive={isAllergenIconActive}
                        setIsAllergenConfirmationDialogOpened={
                            setIsAllergenConfirmationDialogOpened
                        }
                        secondBoxHeight={secondBoxHeight}
                        isTitleActive={isTitleActive}
                        isProductDescriptionShown={isProductDescriptionShown}
                        isPriceShown={isPriceShown}
                        isProductDescriptionActive={isProductDescriptionActive}
                    />
                </>
            )}
        </div>
    );
}

CardProductSimple.propTypes = {
    product: PropTypes.object.isRequired,
    opacity: PropTypes.string,
    quantity: PropTypes.number,
    isAllergenIconActive: PropTypes.bool,
    setIsAllergenConfirmationDialogOpened: PropTypes.func,
    handleAddProductClick: PropTypes.func,
    handleNutritionalInformationDialogOnCloseEvent: PropTypes.func,
    handleProductSizeDialogOnCloseEvent: PropTypes.func,
    handleRemoveProductFromOrder: PropTypes.func,
    productId: PropTypes.string,
};
